import { AlertStorage } from './types';
import {
  getComparisonKey,
  serializeAlert,
  uniqueAlerts,
  unserializeAlert,
} from './serialize';
import { filterNonNullable } from '@lib/filters';

const STORAGE_KEY = 'hiddenAlerts';

export const createAlertClientStorage = (): AlertStorage => {
  return {
    get,
    save,
    delete: deleteFunc,
    flush,
  };
};

const get: AlertStorage['get'] = async () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return [];
  }

  try {
    let json = window.localStorage.getItem(STORAGE_KEY);

    if (json === null) {
      return [];
    }

    let serialized = JSON.parse(json);

    if (!Array.isArray(serialized)) {
      return [];
    }

    let filtered = serialized.filter((alert): alert is string => {
      return typeof alert === 'string';
    });

    return filtered.map(unserializeAlert).filter(filterNonNullable);
  } catch (e) {
    return [];
  }
};

const save: AlertStorage['save'] = async alertArg => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return false;
  }

  let alerts = Array.isArray(alertArg) ? alertArg : [alertArg];

  if (alerts.length === 0) {
    return true;
  }

  let current = await get();
  let updated = uniqueAlerts([...current, ...alerts]);
  let serialized = updated.map(serializeAlert);

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(serialized));

  return true;
};

const deleteFunc: AlertStorage['delete'] = async alertsArg => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return false;
  }

  let alerts = Array.isArray(alertsArg) ? alertsArg : [alertsArg];

  let keysToDelete = alerts.map(alert => getComparisonKey(alert));

  let current = await get();
  let updated = current.filter(alert => {
    return !keysToDelete.includes(getComparisonKey(alert));
  });
  let serialized = updated.map(serializeAlert);

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(serialized));

  return true;
};

const flush: AlertStorage['flush'] = async () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return false;
  }

  window.localStorage.removeItem(STORAGE_KEY);

  return true;
};
